import { render } from "./DomainLabel.vue?vue&type=template&id=be8c3faa"
import script from "./DomainLabel.vue?vue&type=script&lang=js"
export * from "./DomainLabel.vue?vue&type=script&lang=js"

import "./DomainLabel.vue?vue&type=style&index=0&id=be8c3faa&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__